<template>
    <div id="page-duplication-detail">
        <div class="vx-card p-3">
            <vs-tabs>
                <vs-tab label="Danh sách nghi gian lận">
                    <div>
                        <duplication-list-tab :date="date" :data="duplications" @changeRead="changeRead" />
                    </div>
                </vs-tab>
                <vs-tab v-if="$acl.check('fetchMemberReadPermission')" :badge="member_read" label="Danh sách đã xem">
                    <div>
                        <member-read-tab @removeRead="onRemoveRead" />
                    </div>
                </vs-tab>
                <vs-tab v-if="$acl.check('fetchMemberReadPermission')" label="Danh sách muốn xem">
                    <div>
                        <member-watch-tab @removeRead="onRemoveRead" />
                    </div>
                </vs-tab>
            </vs-tabs>
        </div>
    </div>
</template>

<script>
import DuplicationListTab from './DuplicationListTab';
import MemberReadTab from './MemberReadTab.vue';
import MemberWatchTab from './MemberWatchTab.vue';
import { AclRule } from 'vue-acl';

export default {
    data(){
        return {
            date: "",
            duplications: [],
            member_read: 0
        }
    },
    components: {
        DuplicationListTab,
        MemberReadTab,
        MemberWatchTab
    },
    computed:{
        fetchDuplicationPermission: function(){
            return new AclRule('store_duplication').generate()
        },
        fetchMemberReadPermission(){
            return new AclRule('store_member_read').generate();
        }
    },
    watch: {
        date: function(newDate){
            this.fetchDuplication(newDate);
        }
    },
    beforeRouteUpdate (to, from, next) {
        this.date = to.query.date;
        next();
    },
    methods:{
        fetchDuplication(date) {
            if(this.$acl.not.check('fetchDuplicationPermission')) return;
            let vm = this;
            
            this.$http.get("duplication?date="+date).then((res) => {
                vm.duplications = res.data.data.duplication;
                vm.member_read = res.data.data.member_read;
            });
        },
        changeRead(memberName){
            this.member_read++;
            this.duplications = this.duplications.filter(e => {
                return e.member_key != memberName;
            });
        },
        onRemoveRead(){
            this.fetchDuplication(this.date);
        }
    },
    created(){
        if(this.$route.query.date && this.$route.query.date == "this_week"){
            this.date = "this_week";
            this.fetchDuplication("this_week");
            return;
        }
        this.$router.replace({ path: "/duplication?date=this_week" });
    }
};
</script>

<style>
.swal2-container{
    z-index: 99999;
}
#page-duplication-detail .vs-button{
    padding: 10px !important;
}
</style>
